export default __webpack_public_path__ + "static/media/frame.d8ac2cb6.svg";